import React from 'react'
import SbEditable from 'storyblok-react'
import Label from 'src/components/Label'
import Heading from 'src/components/Heading'
import RichText from 'src/utils/RichText'

const SimpleCentered = ({ blok }) => {
  return (
    <SbEditable content={blok} key={blok._uid}>
      <div className="">
        <div
          className={`max-w-7xl mx-auto px-6 
                    lg:${blok.marginTop ? `mt-${parseInt(blok.marginTop, 10) + 36}` : 'mt-64'}
                    lg:${blok.marginBottom ? `mb-${parseInt(blok.marginBottom, 10) + 36}` : 'mb-64'}
                    md:${blok.marginTop ? `mt-${parseInt(blok.marginTop, 10) + 16}` : 'mt-44'}
                    md:${blok.marginBottom ? `mb-${parseInt(blok.marginBottom, 10) + 16}` : 'mb-44'}
                     ${blok.marginTop ? `mt-${blok.marginTop}` : 'mt-28'}
                     ${blok.marginBottom ? `mb-${blok.marginBottom}` : 'mb-28'}`}
        >
          <div className="text-center">
            <Label className="text-lightblue-300" p={true}>
              {blok.label}
            </Label>
            <Heading
              size="h2"
              className="text-darkblue brightgreenBoldNormal max-w-[830px] mx-auto lg:mt-6 mt-4 lg:!mb-10 !mb-6"
            >
              <RichText>{blok.title}</RichText>
            </Heading>
            <div className="prose font-display text-sm lg:text-base text-darkblue-700 max-w-xl mx-auto">
              <RichText>{blok.description}</RichText>
            </div>
          </div>
        </div>
      </div>
    </SbEditable>
  )
}

export default SimpleCentered
